import { Chip, CircularProgress, Stack, Tooltip } from '@mui/material';

import AlertCircleIcon from '@/components/Icons/AlertCircleIcon';
import AlertTriangleIcon from '@/components/Icons/AlertTriangleIcon';
import DotIcon from '@/components/Icons/Animated/DotIcon';
import MoonIcon from '@/components/Icons/MoonIcon';
import SlashIcon from '@/components/Icons/SlashIcon';
import StopCircleIcon from '@/components/Icons/StopCircleIcon';
import {
  STATUS_COLORS,
  STATUS_COLORS_UNKNOWN,
  STATUS_DESCRIPTORS,
  STATUS_TOOLTIP,
  STATUS_TOOLTIP_UNKNOWN,
  STATUS_UNKNOWN_DESCRIPTOR,
} from '@/constants';
import { ChainDeploymentStatus, DeploymentStatus } from '@/graphql';

import { IconWrapper } from './styled';
import { StatusBadgeProps } from './types';

const PROGRESS_ICON = (
  <IconWrapper>
    <CircularProgress size={10} />
  </IconWrapper>
);

export const iconForStatus: Record<DeploymentStatus | ChainDeploymentStatus, JSX.Element> = {
  [DeploymentStatus.BuildingModel]: PROGRESS_ICON,
  [DeploymentStatus.BuildingModelFailed]: <AlertCircleIcon color="error" />,
  [DeploymentStatus.BuildingModelStopped]: <StopCircleIcon color="secondary" />,
  [DeploymentStatus.DeactivatedModel]: <SlashIcon color="secondary" />,
  [DeploymentStatus.DeactivatingModel]: PROGRESS_ICON,
  [DeploymentStatus.DeployingModel]: PROGRESS_ICON,
  [DeploymentStatus.ModelDeployFailed]: <AlertCircleIcon color="error" />,
  [DeploymentStatus.ModelDneError]: <AlertCircleIcon color="error" />,
  [DeploymentStatus.ModelLoading]: PROGRESS_ICON,
  [DeploymentStatus.ModelReady]: <DotIcon color="success" />,
  [DeploymentStatus.ModelUnhealthy]: <AlertTriangleIcon color="warning" />,
  [DeploymentStatus.ScaledToZero]: <MoonIcon color="secondary" />,
  [DeploymentStatus.ScalingFromZero]: PROGRESS_ICON,
  [DeploymentStatus.Updating]: PROGRESS_ICON,
  [DeploymentStatus.MigratingWorkloadPlanes]: PROGRESS_ICON,
};

function StatusBadge({ status, label, tooltip }: StatusBadgeProps) {
  return (
    <Tooltip title={tooltip ?? STATUS_TOOLTIP[status] ?? STATUS_TOOLTIP_UNKNOWN} placement="bottom">
      <Stack direction="row">
        <Chip
          icon={iconForStatus[status]}
          size="small"
          label={label || (STATUS_DESCRIPTORS[status] ?? STATUS_UNKNOWN_DESCRIPTOR)}
          color={STATUS_COLORS[status] ?? STATUS_COLORS_UNKNOWN}
        />
      </Stack>
    </Tooltip>
  );
}

export default StatusBadge;
